import api from '@/api/api';
import useAxios from '@/utils/useAxios';
import { getStorage, setStorage } from '@/fe/utils';
import { useGlobalStore } from '@/store/globalStore';
import projectConfig from '@/config/config';
import { AxiosRequestConfig } from 'axios';
import { Toast } from 'vant';
import { v4 as uuidv4 } from 'uuid'; // 生成uuid
import dayjs from 'dayjs';
import ImageMagicAdapter from 'image-magic-adapter';
// 上传图片的最大值，单位M
export const uploadMaxSize = 10;
// 平台类型
export const platformType = 'h5';

// 获取一个32位uuid
export function uuid(): string {
  return uuidv4().replace(/-/g, '');
}

/**
 * 清除用户token 及其他缓存数据
 */
export function clearToken() {
  localStorage.removeItem(projectConfig.tokenKey);
  localStorage.removeItem('userData');
  useGlobalStore().setAcquired(false);
}

/**
 * 获取菜单及权限
 * @param config {AxiosRequestConfig} axios请求配置项
 * @returns {any}
 */
export function getPermission(config?: AxiosRequestConfig): Promise<any> {
  return new Promise(async (resolve, reject) => {
    let isCheck = config && config.isCheck;
    if (typeof isCheck !== 'boolean') isCheck = true;
    // getPermission在登录时 和 路由钩子中都会调用
    // 登录时调用 isCheck不用配置 默认为true正常请求
    // 路由钩子中调用 请配置isCheck===false需要特殊处理 返回状态 由路由钩子retur ptah重定向的方式跳转
    try {
      let res = await useAxios<any>({ ...config, method: 'post', url: api.getUserMenuTree, data: {} });
      if (isCheck) {
        // res是不包含code的数据
        resolve(res);
      } else {
        // res是包含code的数据
        if (res.code === 200) {
          useGlobalStore().setAcquired(true); // 标记用户权限 已获取
          resolve({ status: 0, data: res.data });
        } else if (res.code === 403 || res.code === 401) {
          clearToken();
          resolve({ status: 1, data: '/login' });
        } else {
          resolve({ status: 1, data: '/error/500' });
        }
      }
    } catch (error) {
      if (isCheck) {
        reject(error);
      } else {
        resolve({ status: 1, data: '/error/500' });
      }
    }
  });
}

// 获取地址栏所有参数
export function getQueryAll() {
  let queryUrl = '';
  if (window.location.search) {
    queryUrl = window.location.search.substring(1);
  } else if (window.location.hash) {
    // 第一个问号后的都视为query
    queryUrl = window.location.hash.substring(window.location.hash.indexOf('?') + 1);
  } else {
    return {};
  }
  let rtn: any = {};
  const queryList = queryUrl.split('&');
  queryList.forEach(el => {
    const key = el.substring(0, el.indexOf('='));
    const value = el.substring(el.indexOf('=') + 1);
    rtn[key] = value;
  });
  return rtn;
}

/**
 * 获取字典数据
 * @param key {string} 某个字典key 为空则返回全部字典集合
 * @param reload {boolean} 是否重新请求接口获取最新数据 默认值false
 * @returns {any}
 */

// export function getDict(key: string): Promise<Dict[]>;
// export function getDict(key: '', reload: boolean): Promise<DictAll>;
// export function getDict(key: string, reload: boolean = false): Promise<Dict[] | DictAll> {
//   return new Promise(async (resolve, reject) => {
//     let _dict = getStorage('sysDict') || {};
//     if (reload || !(Object.keys(_dict).length > 0)) {
//       let result = await useAxios.post(api.queryDictAll);
//       setStorage('sysDict', result);
//       _dict = result;
//     }
//     resolve(key ? _dict[key] : _dict);
//   });
// }

function dataURItoBlob(dataURI: string) {
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = window.atob(dataURI.split(',')[1].replace(/%3D|\s/g, ''));
  else byteString = unescape(dataURI.split(',')[1]);

  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

// 复制canvans并清除周围多余的空白
export function cropSignatureCanvas(canvas: HTMLCanvasElement) {
  const croppedCanvas = document.createElement('canvas'),
    croppedCtx = croppedCanvas.getContext('2d') as CanvasRenderingContext2D;

  croppedCanvas.width = canvas.width;
  croppedCanvas.height = canvas.height;
  croppedCtx.drawImage(canvas, 0, 0);

  let w = croppedCanvas.width,
    h = croppedCanvas.height,
    pix: any = { x: [], y: [] },
    imageData = croppedCtx.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height),
    x,
    y,
    index;

  for (y = 0; y < h; y++) {
    for (x = 0; x < w; x++) {
      index = (y * w + x) * 4;
      if (imageData.data[index + 3] > 0) {
        pix.x.push(x);
        pix.y.push(y);
      }
    }
  }
  pix.x.sort(function (a: any, b: any) {
    return a - b;
  });
  pix.y.sort(function (a: any, b: any) {
    return a - b;
  });
  const n = pix.x.length - 1;

  w = pix.x[n] - pix.x[0];
  h = pix.y[n] - pix.y[0];
  const cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h);

  croppedCanvas.width = w;
  croppedCanvas.height = h;
  croppedCtx.putImageData(cut, 0, 0);

  return croppedCanvas.toDataURL();
}

export const getTicket = async (uploadType: string, fileExt: string) => {
  const res = await useAxios.post(api.getUploadTicket);
  return {
    policy: res.policy,
    OSSAccessKeyId: res.ossAccessKeyId,
    signature: res.signature,
    dir: res.dir,
    host: res.host,
    key: `${res.dir}/web/${platformType}/${uploadType}/${dayjs().format('YYYYMMDD')}/${uuid()}.${fileExt}`,
    success_action_status: '200'
  };
};

// 文件上传
export const uploadFile = async (base64string: string, fileName: string, uploadType: string) => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    const fileExt = fileName.split('.')[1];
    const ticketConfig = await getTicket(uploadType, fileExt);
    formData.append('policy', ticketConfig.policy);
    formData.append('OSSAccessKeyId', ticketConfig.OSSAccessKeyId);
    formData.append('success_action_status', '200');
    formData.append('signature', ticketConfig.signature);
    formData.append('key', ticketConfig.key);
    formData.append('file', new File([dataURItoBlob(base64string)], fileName));
    try {
      const res = await useAxios.post(api.upload, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        isCheck: false
      });
      resolve(ticketConfig.host + '/' + ticketConfig.key);
    } catch (error) {
      reject(error);
    }
  });
};

// 图片压缩功能
export async function compressImage(
  file: File,
  quality: number = 0.8,
  maxWidth: number = 1920,
  maxHeight: number = 1080
): Promise<File> {
  console.log('compressImage函数被调用，传入的参数:', file);
  console.log('参数类型检查 - 是否为File:', file instanceof File);
  console.log('参数类型检查 - 是否为Blob:', file instanceof Blob);
  console.log('参数类型:', typeof file);

  try {
    // 首先检查传入的是否为File或Blob对象
    if (
      !(
        file &&
        ((typeof File !== 'undefined' && file instanceof File) || (typeof Blob !== 'undefined' && file instanceof Blob))
      )
    ) {
      throw new Error('传入的参数不是File或Blob对象');
    }

    // 将File转换为image对象进行处理
    return new Promise((resolve, reject) => {
      console.log('开始创建FileReader');
      const reader = new FileReader();

      reader.onload = function (e: any) {
        console.log('FileReader onload 事件触发');
        const img = new Image();
        img.src = e.target.result;

        img.onload = function () {
          console.log('图片加载完成');
          // 计算压缩后尺寸，保持宽高比
          let { width, height } = img;
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = width * ratio;
            height = height * ratio;
          }

          // 创建canvas进行压缩
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          if (!ctx) {
            reject(new Error('Canvas context not supported'));
            return;
          }

          canvas.width = width;
          canvas.height = height;

          // 绘制压缩后的图片
          ctx.drawImage(img, 0, 0, width, height);

          // 将canvas转换为Blob
          canvas.toBlob(
            blob => {
              if (blob) {
                // 创建新的File对象
                const newFile = new File([blob], file.name, {
                  type: file.type || 'image/jpeg',
                  lastModified: file.lastModified || Date.now()
                });

                console.log(
                  `文件压缩成功: ${file.size} bytes -> ${newFile.size} bytes (${((newFile.size / file.size) * 100).toFixed(2)}%)`
                );

                // 如果压缩后文件更大，返回原始文件
                if (newFile.size >= file.size) {
                  console.warn('压缩后文件更大，使用原始文件');
                  resolve(file);
                } else {
                  resolve(newFile);
                }
              } else {
                reject(new Error('Canvas toBlob failed'));
              }
            },
            'image/jpeg',
            quality
          );
        };

        img.onerror = function () {
          console.error('图片加载失败');
          reject(new Error('图片加载失败'));
        };
      };

      reader.onerror = error => {
        console.error('FileReader读取文件失败:', error);
        reject(new Error('文件读取失败'));
      };

      console.log('准备调用reader.readAsDataURL');
      reader.readAsDataURL(file);
    });
  } catch (error) {
    console.error('图片压缩失败:', error);
    throw error;
  }
}
